import { FeatureName, useGrippContext, useIsFeatureEnabled, useStorageKeys } from '@gripp/shared-logic';
import { IconName, NavigationButton } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { MenuLink, NavLinkProps } from '../../dashboard/components/menuLink';

export const AssetMenuItem = (props: NavLinkProps) => {
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = location.pathname.includes(props.route);
  const storageKeys = useStorageKeys();
  const { storageHandler } = useGrippContext();

  const onClick = async () => {
    await storageHandler.deleteItem(storageKeys.assetsScrollData);
    navigate(props.route);
  };

  // TODO: Crop Circle Redesign | Remove MenuLink after the release
  if (!isCropCircleRedesignEnabled) {
    return (
      <MenuLink
        icon={props.icon}
        title={t(props.titleKey)}
        isActive={isActive}
        onPress={onClick}
      />
    );
  }

  return (
    <NavigationButton
      icon={props.icon as IconName}
      text={t(props.titleKey)}
      active={isActive}
      showIcon={true}
      showText={true}
      mode="light"
      collapsed={props.collapsed}
      onPress={onClick}
    />
  )
};
